import {useEffect, useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import Selector from '../../../selectors/layers/login';
import {authorize, guest} from '../../../reducers/auth/actions';
import {useNavigate} from 'react-router-dom';
import MaskedInput from 'react-text-mask';
import Animation from './animation';
import Language from '../../../language';
import Toolbar from './toolbar';
import {isMobile} from '../../../utils/viewport';

export default () => {
    const {isAuth, error: reducerError, buttons} = useSelector(Selector),
          dispatch = useDispatch(),
          navigate = useNavigate();

    const [error, setError] = useState({
        text: null,
        key: 0
    });

    useEffect(() => {
        if(isAuth) {
            const layer = document.querySelector('.screen.login-layer');
                  layer.classList.remove('animate__zoomIn');
                  layer.classList.add('animate__zoomOut');

            const toolbar = document.querySelector('.login-toolbar');
                  toolbar.classList.remove('animate__fadeIn');
                  toolbar.classList.add('animate__fadeOut');

            setTimeout(() => navigate('/home'), 1e3);
        }
    }, [isAuth]);

    useEffect(() => {
        setError({
            text: reducerError,
            key: Math.floor(Math.random() * 1e3)
        });
    }, [reducerError]);

    const [state, setState] = useState({
        initialized: false,
        data: {
            username: "",
            password: ""
        }
    });

    useEffect(() => {
        if(!state.initialized) {
            const layer = document.querySelector('.screen.login-layer');

            if(layer.classList.contains('animate__zoomOut')) {
                layer.classList.remove('animate__zoomOut');
                layer.classList.add('animate__zoomIn');
            }

            const toolbar = document.querySelector('.login-toolbar');

            if(toolbar.classList.contains('animate__fadeOut')) {
                toolbar.classList.remove('animate__fadeOut');
                toolbar.classList.add('animate__fadeIn');
            }

            setState({
                ...state,
                initialized: true
            });

            if(isMobile())
                Animation.init();
            else
                Animation.start();
        }
    }, [state.initialized])

    useEffect(() => {
        if(error.key === 0)
            return;
    
        clearTimeout(window.errorHideTimeout);
        clearTimeout(window.removeErrorTextTimeout);

        const error_element = document.querySelector('.login-error');

        if(!error_element)
            return;

        error_element.classList.remove('animate__bounceOut');
        error_element.classList.add('animate__bounceIn');

        window.errorHideTimeout = setTimeout(() => {
            error_element.classList.remove('animate__bounceIn');
            error_element.classList.add('animate__bounceOut');

            window.removeErrorTextTimeout = setTimeout(() => {
                setError({...error, text: null});
            }, 600);
        }, 2e3);
    }, [error.key]); 

    return (
        <>
            <Toolbar />
            <div className="screen login-layer animate__animated animate__zoomIn">
                {error.text && <div className="login-error">{error.text}</div>}

                <div className="login-animation"></div>
                <div className="name">EXITO</div>

                <div className="login-form">
                    <div className="welcome-message">{Language('layers.login.title')}</div>
                    <div className="inputs">
                        <div className="input">
                            <MaskedInput 
                                type="text"
                                mask={[
                                    /[0-9]/,
                                    /[0-9]/,
                                    /[0-9]/,
                                    /[0-9]/,
                                    /[0-9]/,
                                    /[0-9]/,
                                ]}
                                guide={false}
                                placeholder={Language('layers.login.name')} 
                                spellCheck="false" 
                                autoCorrect="false" 
                                autoCapitalize="off" 
                                autoComplete="false" 
                                inputMode="numeric"
                                defaultValue={state.data.username}
                                autoFocus
                                onChange={e => setState({
                                    ...state,
                                    data: {
                                        ...state.data,
                                        username: e.target.value
                                    }
                                })} />
                        </div>

                        <div className="input">
                            <MaskedInput 
                                type="password"
                                mask={[
                                    /[0-9]/,
                                    /[0-9]/,
                                    /[0-9]/,
                                    /[0-9]/,
                                    /[0-9]/,
                                    /[0-9]/,
                                ]}
                                guide={false}
                                placeholder={Language('layers.login.password')} 
                                spellCheck="false" 
                                autoCorrect="false" 
                                autoCapitalize="off" 
                                autoComplete="false" 
                                inputMode="numeric"
                                defaultValue={state.data.password}
                                autoFocus
                                onChange={e => setState({
                                    ...state,
                                    data: {
                                        ...state.data,
                                        password: e.target.value
                                    }
                                })} />
                        </div>
                    </div>
                    <div className="buttons">
                        <button
                            className="btn btn-blue"
                            style={{float: 'left'}}
                            onClick={e => {
                                if(buttons.auth || buttons.guest)
                                    return;

                                dispatch(authorize(state.data));
                            }}
                            disabled={buttons.auth}>{Language('layers.login.login')}</button>

                        <button
                            className="btn btn-yellow"
                            style={{float: 'right'}}
                            onClick={e => {
                                if(buttons.auth || buttons.guest)
                                    return;

                                dispatch(guest());
                            }}
                            disabled={buttons.guest}>{Language('layers.login.guest')}</button>
                    </div>
                </div>
            </div>
        </>
    )
}